import React from 'react';
import type { ResolvedWarning, WarningToken } from '@/shared/warnings/types';
// NI transformation for council tax → council rates
import { replaceCouncilTaxWithRates } from '@/shared/lib/niSchemaTransformer';

type Props = {
  warnings: ResolvedWarning[];
  onTokenClick?: (token: WarningToken) => void;
  /** When true, transforms "council tax" to "council rates" for NI users */
  isNorthernIreland?: boolean;
};

const WarningPanel: React.FC<Props> = ({ warnings, onTokenClick, isNorthernIreland = false }) => {
  if (!warnings || warnings.length === 0) return null;

  // Helper to apply NI transformation if needed
  const transformForNI = (text: string): string => {
    return isNorthernIreland ? replaceCouncilTaxWithRates(text) : text;
  };

  return (
    <div style={{
      background: '#fff',
      border: '1px solid #f0c2c2',
      borderRadius: 8,
      padding: 12,
      marginBottom: 12
    }}>
      {warnings.map((w) => (
        <div key={w.id} style={{ marginBottom: 8 }}>
          <div style={{ color: '#b00020', fontWeight: 600, fontSize: 14 }}>
            {/* Render resolved text and clickable tokens as chips */}
            {transformForNI(w.resolvedText || '')}
          </div>
          {w.tokens && w.tokens.length > 0 && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
              {w.tokens.map((t) => (
                <button
                  key={`${w.id}:${t.varId}`}
                  type="button"
                  onClick={() => onTokenClick?.(t)}
                  style={{
                    background: '#ffe9e9',
                    color: '#b00020',
                    border: '1px solid #f0c2c2',
                    borderRadius: 16,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                  aria-label={`Edit ${transformForNI(t.label)}`}
                >
                  {transformForNI(t.label)}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default WarningPanel;


